import { ADD_SYSTEM_MESSAGE } from '../actions/types';
import { PostDispatch, SystemMessage } from '../types';

const SystemMessagesReducer = (
    state: Array<SystemMessage> = [],
    action: PostDispatch
) => {
    switch (action.type) {
        case ADD_SYSTEM_MESSAGE:
            return [action.payload as SystemMessage];
        default:
            return state;
    }
};

export default SystemMessagesReducer;
